<template>
  <Head>
    <Title>Vánoční focení - Ludmila Zacharová</Title>
  </Head>
  <siteblocks-navmenu />
  <v-container>
    <v-sheet class="mx-4">
      <h1>Vánoční focení</h1>
      <div class="mb-5">
        <br>Vánoční focení je můj koníček. Každý rok připravuji hezké dekorace ve svém útulném domácím ateliéru.
        Focení probíhá v klidu, nikdy nespěchám. Výhodou domácího ateliéru je také to, že je snadné si vybrat vhodný termín.
        Navíc je to levnější, protože nemusím platit za pronájem ateliéru. V domácím ateliéru používám profesionální světla, blesky a softboxy.
        Samotné focení probíhá formou hry, což děti baví.
        <br><br>Mám rodiny, které ke mně přicházejí každý rok – už je to tradice.
        A jsou si jisté, že každý rok budou nové dekorace. A pokaždé dostanou nádherné fotografie, které potěší jejich blízké.
        Každá fotografie je totiž jako hezká, roztomilá pohlednice. Tady najdete fotografie z minulých let.
        <br><br>
      </div>
    </v-sheet>
    <v-row v-for="index in 31">
      <v-col cols="12" md="6">
        <v-img :src="'vanoce/' + (index * 2 - 1) + '.jpg'" />
      </v-col>
      <v-col cols="12" md="6">
        <v-img :src="'vanoce/' + (index * 2) + '.jpg'" />
      </v-col>
    </v-row>
  </v-container>
</template>